export const environment = {
  production: false,
  msal: {
		clientId: '63d559e5-3987-4b91-a60a-5b55e5d13da8',
		logoutUri: 'https://acc.sitemanagement.xom.cloud',
		redirectUri: 'https://acc.sitemanagement.xom.cloud/callback',
		authority: 'https://login.microsoftonline.com/EMCloudAD.onmicrosoft.com',
		apiScopes: ['api://4494c879-434c-4fd6-8860-577fe5b70dba/sitemanagement-acc/User'],
	},
  mapSettings: {
    mapOptions: {
      maxZoom: 22,
      minZoom: 0,
      zoomSnap: 0,
      zoomControl: false
    },
    startingZoom: 17,
    maxNativeZoom: 19
  },
  apiUrl: 'https://api.acc.sitemanagement.xom.cloud/api/',
};
